import React from "react";
import DashboardLayout from "../../components/DashboardLayout";
import SupportChat from "../../components/SupportChat";
import { Gauge, CalendarBlank, PlusCircle, Sparkle, Robot, ChartBar, Storefront, Bank, QrCode, IdentificationCard, Lifebuoy, ShieldCheck, Tag, Users, UsersThree, Wallet } from "@phosphor-icons/react";

const ORG_NAV = [
  { to: "/organizer", label: "Dashboard", icon: Gauge, end: true },
  { to: "/organizer/events", label: "My Events", icon: CalendarBlank },
  { to: "/organizer/events/new", label: "Create Event", icon: PlusCircle },
  { to: "/organizer/coupons", label: "Coupons", icon: Tag },
  { to: "/organizer/guests", label: "Guests & RSVP", icon: Users },
  { to: "/organizer/attendees", label: "Attendees", icon: UsersThree },
  { to: "/organizer/wallet", label: "Services Wallet", icon: Wallet },
  { to: "/organizer/package-builder", label: "AI Package Builder", icon: Sparkle },
  { to: "/organizer/copilot", label: "AI Copilot", icon: Robot },
  { to: "/organizer/analytics", label: "Analytics", icon: ChartBar },
  { to: "/organizer/services", label: "Services", icon: Storefront },
  { to: "/organizer/settlements", label: "Settlements", icon: Bank },
  { to: "/organizer/checkin", label: "Event Check-in", icon: QrCode },
  { to: "/organizer/access", label: "Checkers & Access", icon: ShieldCheck },
  { to: "/organizer/onboarding", label: "KYC & Onboarding", icon: IdentificationCard },
  { to: "/organizer/support", label: "Help & Support", icon: Lifebuoy },
];

export default function OrganizerLayout() {
  return (
    <>
      <DashboardLayout nav={ORG_NAV} kicker="Organizer" walletChip tutorialTo="/organizer/tutorial" />
      <SupportChat />
    </>
  );
}
